/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { postForm } from 'js/actions/formsAction';
import { deleteLastPostForm } from 'js/actions/formsAction';

import { Button, TextField, Grid2 } from '@mui/material';

import { makeStyles } from '@mui/styles';
import styles from './styles';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(styles);

function RangosMedicionForm(props) {
  const intl = useIntl();
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();

  const handleBack = () => {
    dispatch(deleteLastPostForm());
    props.prevStep();
  };

  const onSubmit = (values) => {
    dispatch(postForm(values));
    props.nextStep();
  };

  const isValid = (txt) => {
    let bValid = true;
    let restricted = ['/', '\\', ':', '?', '*'];

    for (var idx = 0; idx < restricted.length; idx++) {
      if (txt.indexOf(restricted[idx]) > -1) {
        return false;
      }
    }
    return bValid;
  };

  const classes = useStyles();

  return (
    <Grid2 className={classes.root} container={true}>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <TextField
          className={classes.textField}
          {...register('demanda_min')}
          label="Demanda Mínima"
          name="demanda_min"
          variant="outlined"
        />

        <TextField
          className={classes.textField}
          {...register('demanda_max')}
          label="Demanda Máxima"
          name="demanda_max"
          variant="outlined"
        />

        <TextField
          className={classes.textField}
          {...register('consumo_min')}
          label="Consumo Mínimo"
          name="consumo_min"
          variant="outlined"
        />

        <TextField
          className={classes.textField}
          {...register('consumo_max')}
          label="Consumo Máximo"
          name="consumo_max"
          variant="outlined"
        />

        <Button
          className={classes.button}
          color="secondary"
          size="large"
          type="submit"
          variant="contained"
        >
          {intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.descrip.saveAndContinueLbl',
          })}
        </Button>
        <Button className={classes.backButton} onClick={handleBack}>
          {intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.confirmation.backBtn',
          })}
        </Button>
      </form>
    </Grid2>
  );
}

export default RangosMedicionForm;
